import { FormProvider } from "react-hook-form";
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "../form.css";
import { DropdownComponent } from "../dropdown";
import "../../../common styling";
import { ORDER_TYPE_LIMIT, ORDER_TYPE_MARKET, GetMinStep, 
          BUY, ORDER_TYPE_HIDDEN, ORDER_TYPE_FOK, DURATION_IMMEDIATE, DURATION_DAY, DURATION_GTC, GTC, DAY, 
          IMMEDIATE, ParseFormattedNumber, 
          sessionOptions,
          typeOptions,
          specialTypeOptions,
          DROPDOWN_LIST_NONE,
          durationTypeOptions,
          triggerConditionOptions,
          LIMIT,
          MARKET,
          HIDDEN,
          SESSION,
          DURATION_SESSION,
          TRIGGER_FLAG,
          SCHEDULE_FLAG,
          ConvertToSessionType,
          ConvertToTriggerCondition,
          UNPLACED,
          SESSION_TYPE_NOT_SET,
          triggerDurationTypeOptions} from '../../../common/common'
import { TABLE_ROW_BACKGROUND_COLOR } from "../../../common styling";
import { OrderAmendLogic } from "./order_amend_form_logic";

export const OrderAmendForm = ({rowData, onClose}) => {
  const {
    orderNumber, setOrderNumber, setTradingAccount, verb, setVerb,
    orderType, FOK, durationType, code,
    triggerDurationType, setTriggerDurationType,
    setOrderType, setHidden, setFOK, setDurationType, setCode,
    price, price_dec, qty, qty_dec, 
    visible_qty, setVisibleQty, 
    visible_balance, setVisibleBalance, total_balance, setTotalBalance, 
    triggerCondition, setTriggerCondition,
    triggerPrice, setTriggerPrice,
    specialType, setSpecialType,
    session, setSession,
    qty_step, setQtyStep, price_step, setPriceStep,
    setPrice,
    setQty,
    handleSubmit, onSubmit, setUserId,
    scheduleOrder, setScheduleOrder,
    triggerOrder, setTriggerOrder,
  } = OrderAmendLogic(onClose);

  // setup trading account drop down list, currently for amends you cannot change trading accounts so only has one value
  const [tradingAccountOptions, setTradingAccountOptions] = useState([]); 
  const [orderTrdAcc, setOrderTrdAcc] = useState('');
  const tradingAccountDropDownList = {tradingAccountOptions, selectedValue: orderTrdAcc, default: orderTrdAcc, labelName: 'Account' };

  // const [isPriceDisabled, setIsPriceDisabled] = useState(false);
  const [isVisibleQtyDisabled, setIsVisibleQtyDisabled] = useState(true);
  const [isHiddenDisabled] = useState(false);
  // const [isDayDisabled, setIsDayDisabled] = useState(false);
  // const [isGTCDisabled, setIsGTCDisabled] = useState(false);
  const [verbColor, setVerbColor] = useState('');
  const [disableTrigger, setDisableTrigger] = useState(true);


  // 
  // const [isSessionDisabled, setIsSessionDisabled] = useState(true);
  // const onSessionDropDownChange = useCallback((e) => {setSession(e.target.value)}, [setSession]);
  const [isDurationDisabled] = useState(false); 
  // const [isTriggerPriceDisabled, setIsTriggerPriceDisabled] = useState(false);
  
  const sessionDropDownList = { 
    options: sessionOptions,  
    selectedValue: SESSION_TYPE_NOT_SET,  
    default: 'Select Session', 
    labelName: 'Session' 
  };

  const typeDropDownList = { 
    options: typeOptions,  
    selectedValue: LIMIT,  
    default: LIMIT, 
    labelName: 'Type' 
  };

  const specialTypeDropDownList = { 
    options: specialTypeOptions,  
    selectedValue: DROPDOWN_LIST_NONE,  
    default: DROPDOWN_LIST_NONE, 
    labelName: 'Hidden/FOK' 
  };

  const durationTypeDropDownList = { 
    options: durationTypeOptions,  
    selectedValue: DAY,  
    default: 'Select Duration', 
    labelName: 'Duration' 
  };

  const triggerDurationTypeDropDownList = { 
    options: triggerDurationTypeOptions,  
    selectedValue: DAY,  
    default: 'Select Duration', 
    labelName: 'Duration' 
  };
  
  const triggerConditionDropDownList = { 
    options: triggerConditionOptions,  
    selectedValue: DROPDOWN_LIST_NONE,  
    default: 'Select Directon', 
    labelName: 'Trigger Dir' 
  };

  // initialise the form with values from the clicked row
  useEffect(() => {
    const { price, user, o_num, instr, trdacc, verb, o_type, s_type, dur, orig_qty, vis_qty, vis_bal, tot_bal, o_flags, sess_t, t_price, t_con, t_dur, status  } = rowData;
    if (user) setUserId(user);
    if (o_num) setOrderNumber(o_num);
    if (instr) setCode(instr);
    if (trdacc) {
      setTradingAccount(trdacc);
      setOrderTrdAcc(trdacc);
      setTradingAccountOptions([{ id: trdacc, name: trdacc }]);
    }
    if (verb) setVerb(verb);
    if (verb === BUY) {
      setVerbColor('blue');
    }
    else {
      setVerbColor('red');
    };
    if (o_type) {
      if (o_type === ORDER_TYPE_LIMIT) {
        setOrderType(ORDER_TYPE_LIMIT);
        if (price) {
          setPrice(ParseFormattedNumber(price));
        };
      }
      else {
        setOrderType(ORDER_TYPE_MARKET);
      };
    }
    if (s_type === ORDER_TYPE_HIDDEN) {
      setHidden(true);
      setSpecialType(HIDDEN);
    }
    else if (s_type === ORDER_TYPE_FOK) {
      setFOK(true);
      setSpecialType(FOK);
    }
    else {
      setHidden(false);
      setFOK(false);
    };

    if (o_flags & TRIGGER_FLAG) {
      if ((status === UNPLACED) && (o_flags & SCHEDULE_FLAG)) {
        setDisableTrigger(false);
      }

      setTriggerOrder(true);
      if (t_con) setTriggerCondition(ConvertToTriggerCondition(t_con));
      if (t_price) setTriggerPrice(ParseFormattedNumber(t_price));
    }

    if (o_flags & SCHEDULE_FLAG) {
      if ((status === UNPLACED)) {
        setDisableTrigger(false);
      }
      setScheduleOrder(true);
      if (sess_t) setSession(ConvertToSessionType(sess_t));
    }

    if (dur === IMMEDIATE) {
      setDurationType(DURATION_IMMEDIATE);
    }
    else if (dur === DAY) {
      setDurationType(DURATION_DAY);
    }
    else if (dur === GTC) {
        setDurationType(DURATION_GTC);
    }else if (dur === SESSION) {
        setDurationType(DURATION_SESSION);
    }

    if (t_dur === DAY) {
      setTriggerDurationType(DURATION_DAY);
    }
    else if (t_dur === GTC) {
        setTriggerDurationType(DURATION_GTC);
    }else if (t_dur === SESSION) {
        setTriggerDurationType(DURATION_SESSION);
    }

    if (orig_qty) setQty(ParseFormattedNumber(orig_qty));
    if (vis_qty) setVisibleQty(ParseFormattedNumber(vis_qty));
    if (vis_bal) setVisibleBalance(ParseFormattedNumber(vis_bal));
    if (tot_bal) setTotalBalance(ParseFormattedNumber(tot_bal));
  }, [
    rowData, setUserId, setOrderNumber, setCode, setTradingAccount, setOrderTrdAcc,
    setTradingAccountOptions, setVerb, setVerbColor, setOrderType, setPrice, setHidden,
    setFOK, setDurationType, setQty, setVisibleQty, setVisibleBalance, setTotalBalance, setSpecialType, FOK,
    setScheduleOrder, setSession, setTriggerCondition, setTriggerOrder, setTriggerPrice, setTriggerDurationType
  ]);
  
  useEffect(() => { setQtyStep(GetMinStep(qty_dec)); }, [qty_dec, setQtyStep]);
  useEffect(() => { setPriceStep(GetMinStep(price_dec)); }, [price_dec, setPriceStep]);

  const  onTradingAccountDropDownListChange = (event) => {
    setTradingAccount(event.target.value);
  };

  // const onHiddenCheckClick = (event) => {
  //   if (event.target.checked) {
  //     if (orderType !== ORDER_TYPE_MARKET) {
  //       setHidden(true);
  //       setFOK(false);
  //       setIsVisibleQtyDisabled(false);
  //     }
  //     else {
  //       ShowError('Hidden option not allowed with market orders');
  //     }
  //   }
  //   else {
  //       setHidden(false);
  //       setIsVisibleQtyDisabled(true);
  //       setVisibleQty('');
  //   }
  // };

  const onInputVisibleQty = (e) => { setVisibleQty(e.target.value); };
  const onInputQty = (e) => { setQty(e.target.value); };

  const handleCancel = () => {
    onClose();
  };


  // // 3. Handle Trigger Order checkbox changes
  // useEffect(() => {
  //   if (triggerOrder) {
  //     setIsTriggerPriceDisabled(false);
  //     // Optionally, you don't need to clear values when enabling
  //   } else {
  //     setIsTriggerPriceDisabled(true);
  //     // setTriggerCondition(DROPDOWN_LIST_NONE);
  //     // setTriggerPrice('');
  //   }
  // }, [triggerOrder, setTriggerCondition, setTriggerPrice]);

  useEffect(() => {
    if (isHiddenDisabled === true) {
      setIsVisibleQtyDisabled(true);
    }
    else {
      setIsVisibleQtyDisabled(false);
    }
  }, [isHiddenDisabled, setVisibleQty]);

  return (
    <>
    <div>
      <FormProvider>
      <div className="order-form-container">
        <form className="window-amend-center" onSubmit={handleSubmit(onSubmit)}>
          <h2 className="order-amend-title">Modify</h2>
          <div className="form-control" style={{borderColor: TABLE_ROW_BACKGROUND_COLOR, backgroundColor: TABLE_ROW_BACKGROUND_COLOR}}>
          <label className="order-label">Order Id</label>
          <input className="form_input" type="text" value={ orderNumber}  disabled={ true }  name="orderNumber" />
          <label className="order-label">Code</label>
          <input className="form_input" type="text" value={ code } disabled={ true } name="code" />
          <DropdownComponent labelName={tradingAccountDropDownList.labelName} default={tradingAccountDropDownList.default} options={tradingAccountDropDownList.tradingAccountOptions} onSearchChange={onTradingAccountDropDownListChange} />           
          <label className="order-label">Verb</label>
          <input type="text" style={{ color:'white', background:verbColor }} value={ verb } disabled={ true } name="code" />
            <DropdownComponent 
              labelName={typeDropDownList.labelName} 
              value={orderType === ORDER_TYPE_LIMIT? LIMIT : MARKET }
              default={typeDropDownList.default} 
              options={typeDropDownList.options} 
              onSearchChange={(e) => setOrderType(e.target.value)} 
              disabled={true} 
            />

            <DropdownComponent 
              labelName={specialTypeDropDownList.labelName} 
              value={specialType}
              default={specialTypeDropDownList.default} 
              options={specialTypeDropDownList.options} 
              onSearchChange={(e) => setSpecialType(e.target.value)} 
              disabled={true} 
            />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <label className="order-label">Price</label>
            <input className="form_input" type="number" step={ price_step } min={ price_step } placeholder='Limit Price' value={price} onChange={(e)=>setPrice(e.target.value)} name="Price" />

            <label className="order-label">Quantity</label>
            <input className="form_input" type="number" name="Quantity" step={ qty_step } min={ qty_step } value={ qty } onInput={onInputQty} />

            <label className="order-label">Balance</label>
            <input className="form_input" type="number" name="Balance" step={ qty_step } min={ qty_step } value={ total_balance } disabled={ true } onInput={onInputQty} />
            {specialType === HIDDEN && (
              <>
              <label className="order-label">Visible&nbsp;Qty</label>
              <input className="form_input" type="number" placeholder="For Hidden Orders" step={ qty_step } value={visible_qty} onInput={onInputVisibleQty} disabled={isVisibleQtyDisabled} name="Visible" />
              
              <label className="order-label">Visible&nbsp;Bal</label>
              <input className="form_input" type="number" step={ qty_step } min={ qty_step } disabled={ true } value={ visible_balance } name="VisibleBalance"/>
              </>
            )}

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />
            
            <DropdownComponent 
              labelName={durationTypeDropDownList.labelName} 
              value={durationType}
              default={durationTypeDropDownList.default} 
              options={durationTypeDropDownList.options} 
              onSearchChange={(e) => setDurationType(e.target.value)} 
              disabled={isDurationDisabled} 
            />

            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'flex-start',  // Changed from 'flex-end' to 'flex-start'
              gap: '50px',
              gridColumn: 1,  // Place in the label column
              alignSelf: 'center',  // Add this - centers the entire div in the grid row
              //margin: 'auto 0'      // Add this as well
              margin: '0 0 8px 0'
            }}>
              
              <label className="order-label" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                Schedule Order
              </label>
              <input
                  type="checkbox"
                  style={{ transform: 'scale(1)', margin: 0, cursor: 'pointer' }} 
                  checked={scheduleOrder}
                  onChange={(e) => setScheduleOrder(e.target.checked)}
                  disabled={true}
                />
            </div>

            {scheduleOrder && (
              <DropdownComponent 
                labelName={sessionDropDownList.labelName} 
                value={session}
                default={sessionDropDownList.default} 
                options={sessionDropDownList.options} 
                onSearchChange={(e) => setSession(e.target.value)} 
              />
            )}


            {/* Separator line */}
            <hr style={{ 
              gridColumn: '1 / -1',  // Span across both columns
              margin: '15px 0',
              borderTop: '1px solid #ccc',
              width: '100%'
            }} />

            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'flex-start',  // Changed from 'flex-end' to 'flex-start'
              gap: '50px',
              gridColumn: 1,  // Place in the label column
              alignSelf: 'center',  // Add this - centers the entire div in the grid row
              //margin: 'auto 0'      // Add this as well
              margin: '0 0 8px 0' 
            }}>
              
              <label className="order-label" style={{ margin: 0, whiteSpace: 'nowrap' }}>
                Trigger Order
              </label>
              <input
                  type="checkbox"
                  style={{ transform: 'scale(1)', margin: 0, cursor: 'pointer' }} 
                  checked={triggerOrder}
                  onChange={(e) => setTriggerOrder(e.target.checked)}
                  disabled={disableTrigger}
                />
            </div>

            {triggerOrder && (
              <>
                <DropdownComponent 
                  labelName={triggerConditionDropDownList.labelName} 
                  value={triggerCondition}
                  default={triggerConditionDropDownList.default} 
                  options={triggerConditionDropDownList.options} 
                  onSearchChange={(e) => setTriggerCondition(e.target.value)} 
                />

                <label className="order-label">Trigger&nbsp;Price</label>

                <input
                  className="form_input"
                  type="number"
                  step={price_step}
                  min={price_step}
                  placeholder="Trigger Price"
                  value={triggerPrice}
                  onChange={(e) => setTriggerPrice(e.target.value)}
                  name="TriggerPrice"
                />

                <DropdownComponent 
                  labelName={triggerDurationTypeDropDownList.labelName} 
                  value={triggerDurationType}
                  default={triggerDurationTypeDropDownList.default} 
                  options={triggerDurationTypeDropDownList.options} 
                  onSearchChange={(e) => setTriggerDurationType(e.target.value)} 
                />
              </>
            )}
            
            <Button className="orderbutton" variant="secondary" size="lg" type="button" onClick={handleCancel}>Cancel</Button>
            <Button className="orderbutton" variant="success" size="lg" type="submit"  style={{float: 'right'}} >Modify</Button>
          </div>
        </form>
      </div>
      </FormProvider>
    </div>
    </>
  );
}
